module.exports = __webpack_public_path__ + "static/agro-a19880b56cb9787cfe49c3bb045db4c2.png";